import { Texts } from '../../../pure-js/libs/Texts'
import { resolveActivityLocationReceiptFields } from '../../../pure-js/libs/RoomHelpers'
import Box from './Box'
import { TWELVE_PX } from '../enums/Spacings'
import { Activity, Client } from '../../../pure-js/types/GrooverTypes'
import { memo } from 'react'
import { getWeekdayAbbreviation } from '../libs/DayJsHelper'
import ExpandedActivityDetail from './ExpandedActivityDetail'
import { GreyLine } from './StyledComponents'

type Props = {
  activity: Activity
  client?: Client | null
  onOpenGoogleMaps: (e: React.MouseEvent<HTMLDivElement>) => void
}

const ExpandedActivityDetails = ({ activity, client, onOpenGoogleMaps }: Props) => {
  const { locationDisplayName, locationAddress } = resolveActivityLocationReceiptFields(activity, client)

  return (
    <Box fullWidth top gap={TWELVE_PX}>
      <ExpandedActivityDetail
        labelTextKey={Texts.registrationStep6SummarySummaryStartdateLabel}
        valueText={activity.startDate}
      />

      <GreyLine />

      <ExpandedActivityDetail
        labelTextKey={Texts.registrationStep6SummarySummaryDayAndTimeLabel}
        valueText={`${getWeekdayAbbreviation(activity.startDate)} ${activity.time}`}
      />

      <GreyLine />

      <ExpandedActivityDetail
        labelTextKey={Texts.registrationStep6SummarySummaryOccurencesLabel}
        valueText={String(activity.noOfOccasions)}
      />

      <GreyLine />

      <ExpandedActivityDetail
        labelTextKey={Texts.registrationStep6SummaryActivitySummaryLocation}
        valueText={locationDisplayName || 'N/A'}
      />

      {locationAddress && (
        <>
          <GreyLine />

          <ExpandedActivityDetail
            labelTextKey="registrationStep6SummaryActivitySummaryAddress"
            valueText={locationAddress}
          />
        </>
      )}

      <GreyLine />

      <ExpandedActivityDetail
        labelTextKey={Texts.registrationStep6SummaryActivitySummaryGoogleUrl}
        valueText="Link"
        onClick={onOpenGoogleMaps}
      />
    </Box>
  )
}

export default memo(ExpandedActivityDetails)
